import { ApiEndpointBuilder } from "@/services/api/types.ts";

const deleteContractUserRoleEndpoint = (builder: ApiEndpointBuilder) => {
  return builder.mutation<string, Request>({
    query: request => ({
      url: `/contracts/enterprisecontracts/userrole`,
      method: "DELETE",
      body: request,
    }),
    invalidatesTags: (_r, _e, arg) => [{ type: "contract", id: arg.enterpriseContractId }],
  });
};

export default deleteContractUserRoleEndpoint;

type Request = {
  enterpriseContractId: string;
  employeeId: string;
};
